export interface RegionDataState {
  regionData: any;
}

export const initialRegionDataState: RegionDataState = {
    regionData: null
};
